import { UserEndpoints } from 'src/client/user/constants'
import { DEFAULT_CACHE_CONFIG } from 'src/services/constants'
import { useParams } from 'react-router-dom'
import { jwt } from 'src/utils'
import { useHotRequest } from '@hotmart-org-ca/hot-club-http/client/hooks'
import { APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES } from 'src/config/request/hotClubHttp'
import { GetUserSessionDataResponse } from 'src/client/user/types'
import { useSessionData } from '../useSessionData'

const useUserSessionData = () => {
  const { membership } = useParams()
  const { user } = useSessionData()

  const enabled = !jwt.isExpired(user?.token)
  const url = UserEndpoints.getUserSessionData()

  const response = useHotRequest<GetUserSessionDataResponse>(url, {
    cacheKey: [url],
    instanceName: APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES.API_CONTENT_GATEWAY,
    headers: {
      slug: membership as string
    },
    queryOptions: {
      enabled,
      ...DEFAULT_CACHE_CONFIG
    }
  })

  return {
    ...response,
    enabled,
    isLoading: enabled ? response.isLoading : false
  }
}

export default useUserSessionData
